/**
 * Utilidades para séries estatísticas mensais (janeiro a dezembro).
 */

type EstatisticaMensalItem = {
    codigo?: string | null;
    descricao?: string | null;
    ufSgUf?: string | null;
    ordem?: number | null;
    total?: number | null;
};

export class EstatisticaMensalUtils {
    private static readonly NOMES_MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

    /**
     * Preenche com total 0 os meses ausentes de uma série mensal, para o eixo do gráfico
     * não pular meses quando a API retorna apenas os meses com dados.
     *
     * A série é reconhecida pelo campo `ordem` (1 a 12). Se algum item não tiver `ordem`
     * nesse intervalo, ou se houver mais de um item para o mesmo mês, a lista original é
     * retornada sem alteração (não é possível preencher com segurança).
     */
    public static preencherMesesAusentes<T extends EstatisticaMensalItem>(itens: T[]): T[] {
        if (!itens.length) {
            return itens;
        }

        const itensPorMes = new Map<number, T>();

        for (const item of itens) {
            const mes = item.ordem ?? null;

            if (mes === null || !Number.isInteger(mes) || mes < 1 || mes > 12 || itensPorMes.has(mes)) {
                return itens;
            }

            itensPorMes.set(mes, item);
        }

        return Array.from({ length: 12 }, (_, index) => {
            const mes = index + 1;
            const existente = itensPorMes.get(mes);

            if (existente) {
                return existente;
            }

            return {
                codigo: String(mes).padStart(2, '0'),
                descricao: EstatisticaMensalUtils.NOMES_MESES[index],
                ufSgUf: null,
                ordem: mes,
                total: 0
            } as T;
        });
    }
}
